import { GetProcessingReferralRequestsQuery, GetSubmittedReferralsQuery } from '../generated/home';

type CancelTarget = { readonly failed: boolean; readonly referralRequestId: string };

type SubmittedReferralSessionResult = GetSubmittedReferralsQuery['getSubmittedReferrals']['sessions'][number];

type ProcessingReferralRequestResult = GetProcessingReferralRequestsQuery['getProcessingReferralRequests'][number];

type ProcessingReferralRow = ProcessingReferralRequestResult & {
  readonly delayed: boolean;
  readonly kind: 'processing';
};

type SubmittedReferralRow = ProcessingReferralRow | SubmittedReferralSessionResult;

const isProcessingReferralRow = (row: SubmittedReferralRow): row is ProcessingReferralRow => 'kind' in row;

export type {
  CancelTarget,
  ProcessingReferralRequestResult,
  ProcessingReferralRow,
  SubmittedReferralRow,
  SubmittedReferralSessionResult,
};
export { isProcessingReferralRow };
